export default __webpack_public_path__ + "static/media/SML Saarthi Logo.93916f65.svg";